function thresholdReducer(state: any, { type, payload }: any) {
  switch (type.toUpperCase()) {
    case "MODERATE_SYSTOLIC_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          systolic: { ...state.moderate.systolic, low: payload }
        }
      };
    case "MODERATE_SYSTOLIC_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          systolic: { ...state.moderate.systolic, high: payload }
        }
      };
    case "MODERATE_DIASTOLIC_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          diastolic: { ...state.moderate.diastolic, low: payload }
        }
      };
    case "MODERATE_DIASTOLIC_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          diastolic: { ...state.moderate.diastolic, high: payload }
        }
      };
    case "MODERATE_PULSE_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          pulse: { ...state.moderate.pulse, low: payload }
        }
      };
    case "MODERATE_PULSE_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          pulse: { ...state.moderate.pulse, high: payload }
        }
      };
    case "MODERATE_GLUCOSE_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          glucose: { ...state.moderate.glucose, low: payload }
        }
      };
    case "MODERATE_GLUCOSE_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          glucose: { ...state.moderate.glucose, high: payload }
        }
      };
    case "MODERATE_WEIGHT_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          weight: { ...state.moderate.weight, low: payload }
        }
      };
    case "MODERATE_WEIGHT_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          weight: { ...state.moderate.weight, high: payload }
        }
      };
    case "MODERATE_SPO2_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          spo2: { ...state.moderate.spo2, low: payload }
        }
      };
    case "MODERATE_SPO2_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          spo2: { ...state.moderate.spo2, high: payload }
        }
      };
    case "MODERATE_TEMP_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          temp: { ...state.moderate.temp, low: payload }
        }
      };
    case "MODERATE_TEMP_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          temp: { ...state.moderate.temp, high: payload }
        }
      };
    case "MODERATE_FVC_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          FVC: {...state.moderate.FVC, low: payload}
        }
      };
    case "MODERATE_FVC_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          FVC: {...state.moderate.FVC, high: payload}
        }
      };
    case "MODERATE_FEV1_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          FEV1: {...state.moderate.FEV1, low: payload}
        }
      };
    case "MODERATE_FEV1_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          FEV1: {...state.moderate.FEV1, high: payload}
        }
      };
    case "MODERATE_FEV1_FVC_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          FEV1_FVC: {...state.moderate.FEV1_FVC, low: payload}
        }
      };
    case "MODERATE_FEV1_FVC_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          FEV1_FVC: {...state.moderate.FEV1_FVC, high: payload}
        }
      };
    case "MODERATE_PEF_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          PEF: {...state.moderate.PEF, low: payload}
        }
      };
    case "MODERATE_PEF_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          PEF: {...state.moderate.PEF, high: payload}
        }
      };
    case "MODERATE_STEPS_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          steps: {...state.moderate.steps, low: payload}
        }
      };
    case "MODERATE_STEPS_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          steps: {...state.moderate.steps, high: payload}
        }
      };
    case "MODERATE_SLEEP_LOW":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          sleep: {...state.moderate.sleep, low: payload}
        }
      };
    case "MODERATE_SLEEP_HIGH":
      return {
        ...state,
        moderate: {
          ...state.moderate,
          sleep: {...state.moderate.sleep, high: payload}
        }
      };
    case "HIGH_SYSTOLIC_LOW":
      return {
        ...state,
        high: {
          ...state.high,
          systolic: { ...state.high.systolic, low: payload }
        }
      };
    case "HIGH_SYSTOLIC_HIGH":
      return {
        ...state,
        high: {
          ...state.high,
          systolic: { ...state.high.systolic, high: payload }
        }
      };
    case "HIGH_DIASTOLIC_LOW":
      return {
        ...state,
        high: {
          ...state.high,
          diastolic: { ...state.high.diastolic, low: payload }
        }
      };
    case "HIGH_DIASTOLIC_HIGH":
      return {
        ...state,
        high: {
          ...state.high,
          diastolic: { ...state.high.diastolic, high: payload }
        }
      };
    case "HIGH_PULSE_LOW":
      return {
        ...state,
        high: { ...state.high, pulse: { ...state.high.pulse, low: payload } }
      };
    case "HIGH_PULSE_HIGH":
      return {
        ...state,
        high: { ...state.high, pulse: { ...state.high.pulse, high: payload } }
      };
    case "HIGH_GLUCOSE_LOW":
      return {
        ...state,
        high: {
          ...state.high,
          glucose: { ...state.high.glucose, low: payload }
        }
      };
    case "HIGH_GLUCOSE_HIGH":
      return {
        ...state,
        high: {
          ...state.high,
          glucose: { ...state.high.glucose, high: payload }
        }
      };
    case "HIGH_WEIGHT_LOW":
      return {
        ...state,
        high: { ...state.high, weight: { ...state.high.weight, low: payload } }
      };
    case "HIGH_WEIGHT_HIGH":
      return {
        ...state,
        high: { ...state.high, weight: { ...state.high.weight, high: payload } }
      };
    case "HIGH_SPO2_LOW":
      return {
        ...state,
        high: { ...state.high, spo2: { ...state.high.spo2, low: payload } }
      };
    case "HIGH_SPO2_HIGH":
      return {
        ...state,
        high: { ...state.high, spo2: { ...state.high.spo2, high: payload } }
      };
    case "HIGH_TEMP_LOW":
      return {
        ...state,
        high: { ...state.high, temp: { ...state.high.temp, low: payload } }
      };
    case "HIGH_TEMP_HIGH":
      return {
        ...state,
        high: { ...state.high, temp: { ...state.high.temp, high: payload } }
      };
    case "HIGH_FVC_LOW":
      return {
        ...state,
        high: {
          ...state.high,
          FVC: {...state.high.FVC, low: payload}
        }
      };
    case "HIGH_FVC_HIGH":
      return {
        ...state,
        high: {
          ...state.high,
          FVC: {...state.high.FVC, high: payload}
        }
      };
    case "HIGH_FEV1_LOW":
      return {
        ...state,
        high: {
          ...state.high,
          FEV1: {...state.high.FEV1, low: payload}
        }
      };
    case "HIGH_FEV1_HIGH":
      return {
        ...state,
        high: {
          ...state.high,
          FEV1: {...state.high.FEV1, high: payload}
        }
      };
    case "HIGH_FEV1_FVC_LOW":
      return {
        ...state,
        high: {
          ...state.high,
          FEV1_FVC: {...state.high.FEV1_FVC, low: payload}
        }
      };
    case "HIGH_FEV1_FVC_HIGH":
      return {
        ...state,
        high: {
          ...state.high,
          FEV1_FVC: {...state.high.FEV1_FVC, high: payload}
        }
      };
    case "HIGH_PEF_LOW":
      return {
        ...state,
        high: {
          ...state.high,
          PEF: {...state.high.PEF, low: payload}
        }
      };
    case "HIGH_PEF_HIGH":
      return {
        ...state,
        high: {
          ...state.high,
          PEF: {...state.high.PEF, high: payload}
        }
      };
    case "HIGH_STEPS_LOW":
      return {
        ...state,
        high: {
          ...state.high,
          steps: {...state.high.steps, low: payload}
        }
      };
    case "HIGH_STEPS_HIGH":
      return {
        ...state,
        high: {
          ...state.high,
          steps: {...state.high.steps, high: payload}
        }
      };
    case "HIGH_SLEEP_LOW":
      return {
        ...state,
        high: {
          ...state.high,
          sleep: {...state.high.sleep, low: payload}
        }
      };
    case "HIGH_SLEEP_HIGH":
      return {
        ...state,
        high: {
          ...state.high,
          sleep: {...state.high.sleep, high: payload}
        }
      };
    case "SET_ALL_THRESHOLDS":
      return payload;
    case "REMOVE_THRESHOLD": {
      const { breach, key } = payload;
      const updatedBreach = { ...state[breach] };
      delete updatedBreach[key];
      return { ...state, [breach]: updatedBreach };
    }
    case "UPDATE":
      return { ...state, ...payload };
    case "CLEAR":
      return { ...state, ...payload
       };
    default:
      return state;
  }
}

export default thresholdReducer;
